<template>
  <body>
  <app-header/>
  <breadcrumb :list="list"/>
  <div id="download" class="py-5">
    <div class="container-fluid">
      <AppAside/>
      <router-view></router-view>
    </div>
  </div>

  <!--FOOTER-->
  <app-footer/>
  </body>
</template>

<script>
  import nav from '../_nav'
  import {Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb} from '../components/'

  export default {
    name: 'frontend',
    components: {
      AppHeader,
      Sidebar,
      AppAside,
      AppFooter,
      Breadcrumb
    },
    data() {
      return {
        nav: nav.items
      }
    },
    computed: {
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched
      }
    }
  }
</script>

<style>
  header {
    /*min-height: 250px!important;*/
  }

  header.second-header {
    margin-top: 53px;
  }

  .header-image {
    background-image: url("../assets/header.png");
    background-size: 33%;
    background-repeat: no-repeat;
    background-position-x: 10%;
  }

  main.masthead.text-white {
    border-bottom-color: #101734;
    border-top-color: #101734;
    border-bottom-width: medium;
    /*background-image: url("../assets/hand.jpg");*/
  }

  main {
    border-top-color: #101734;
    border-top-width: medium;
  }

  .navbar {
    #background-color: #F99F47;
    border-bottom-color: #101734;
    border-bottom-width: medium;
    color: white;
  }

  .navbar-nav .nav-link, .navbar-nav .navbar .dropdown-toggle, .navbar .navbar-nav .dropdown-toggle {
    color: white;
  }

  .st0 {
    display: none;
  }

  .st1 {
    display: inline;
    fill: #ED1F24;
    stroke: #000000;
    stroke-miterlimit: 10;
  }

  .st2 {
    fill: #041147;
  }

  .st3 {
    opacity: 4.000000e-02;
    stroke: #041147;
    stroke-miterlimit: 10;
  }

  .st4 {
    opacity: 8.000000e-02;
    stroke: #041147;
    stroke-miterlimit: 10;
  }

  .st5 {
    opacity: 0;
    stroke: # #041147;
    stroke-miterlimit: 10;
  }

  .st6 {
    opacity: 8.000000e-02;
  }

  .st7 {
    fill: none;
  }

  .container-fluid {
    width: 100%;
    padding-right: 40px !important;
    padding-left: 40px !important;
    margin-right: auto;
    margin-left: auto;
  }

  .logo_central {
    width: 50%;
    height: auto;
    margin-left: 25%;
  }

  .boton-header {
    color: #898693;
    background: rgb(0, 212, 255);
    /* background: linear-gradient(90deg, rgba(0,212,255,0.025647759103641476) 9%, rgba(182,184,190,0) 12%, rgba(182,184,190,1) 64%);*/
    border-style: hidden;
    border-radius: 35px;
    background-color: #D5D9DE;
  }

  .boton-header:hover > i {
    color: #fff;
    background-color: #5a6268;
    border-color: #545b62;
  }

  .logo {
    height: auto;
    width: 110px;
  }

  @import '../assets/scss/style.scss'
</style>



// WEBPACK FOOTER //
// src/containers/FrontEnd.vue